module.exports = __webpack_public_path__ + "static/img/international-certification.82904375.png";